<template>
  <div>
    <div v-if="rzzt == '0' || rzzt == '1'" class="content">
      <img v-if="rzzt == '0'" src="@images/smrz-s.png" class="img" />
      <img v-else src="@images/smrz-e.png" class="img" />
      <div class="tips success" :class="[rzzt == '0' ? 'success' : 'err']">
        {{ rzzt == '0' ? '认证成功' : '认证失败' }}
      </div>
    </div>
    <div class="u-buttom">
      <button class="qualified"  @click="goback">确定</button>
    </div>
  </div>
</template>

<script>
import { postAction } from '@/api/manage'
import Vue from 'vue'
import { ACCESS_TOKEN } from '@/store/mutation-types'
export default {
  data() {
    return {
      rzzt: '', //0 成功 1失败
      BizToken: '',
      model: {},
    }
  },
  created() {
    this.rzzt = this.$route.query.type;
    // this.BizToken = this.getUrlParams().BizToken
    // console.log(this.BizToken)
    // this.getData()
  },
  methods: {
    goback() {
      //回到首页,
      // let backlen = window.history.length - 1;
      this.$router.go(-1)
    },
    getUrlParams() {
      // 截取url中的code方法
      var url = location.search
      var theRequest = new Object()
      if (url.indexOf('?') != -1) {
        var str = url.substr(1)
        var strs = str.split('&')
        for (var i = 0; i < strs.length; i++) {
          theRequest[strs[i].split('=')[0]] = strs[i].split('=')[1]
        }
      }
      return theRequest
    },
    getData() {
      let url = `/ai/face/recognition/h5/get/detect/info/enhanced?bizToken=${this.BizToken}`
      postAction(url)
        .then((res) => {
          if (res.success) {
            let result = res.result.text
            if (result.errCode == 0) {
              this.uploadData()
            } else {
              this.rzzt = '1'
            }
          } else {
            this.rzzt = '1'
            this.$toast(res.message)
          }
        })
        .catch(() => {
          this.rzzt = '1'
        })
    },
    uploadData() {
      let url = '/system/sysuserwechatbind/detectauth'
      let obj = Vue.ls.get('smxx', {})
      obj.openId = this.$store.getters.openId || ''
      obj.wechatName = obj.name
      postAction(url, obj).then((res) => {
        if (res.success) {
          this.rzzt = '0'
          this.refreshToken();
        } else {
          this.rzzt = '1'
        }
      })
    },
      refreshToken(){
     let url = '/sys/mlogin/refresh/current/token';
          postAction(url)
          .then(res => {
                if(res.token){
                Vue.ls.set(ACCESS_TOKEN,res.token);
                Vue.ls.set('userInfo',res.userInfo);
                Vue.ls.set('roles',res.roles);
            }
        	 })
          
   },
  },
}
</script>

<style lang="less" scoped>
.tips {
  font-weight: 500;
  font-size: 18px;
  margin-top: 10px;
  text-align: center;
}

.success {
  color: #1d6ddb;
}
.err {
  color: #e2614c;
}

.desc {
  font-size: 14px;
  color: #909399;
  margin-top: 10px;
}
.u-buttom {
  padding: 0 15px;
  margin-top: 102px;

  button {
    width: 100%;
    height: 40px;
    line-height: 40px;
    border-radius: 40px;
    font-size: 16px;
    background: #1d6ddb;
    color: #ffffff;
    border: none;
  }
}

.content {
  padding-top: 42px;
  display: flex;
  flex-direction: column;
  align-items: center;
  .img {
    width: 200px;
  }
}
</style>
